/**
 * Constants definition.
 */
const STUDY_LEVELS = {
  NONE: 'NONE',
  PRIMARY: 'PRIMARY',
  PRE_LEVEL: 'PRE_LEVEL',
  OFICIO_LEVEL: 'OFICIO_LEVEL',
  TEC_MEDIO_LEVEL: 'TEC_MEDIO_LEVEL',
  TEC_SUPERIOR_LEVEL: 'TEC_SUPERIOR_LEVEL',
  UNIVERSIDAD_LEVEL: 'UNIVERSIDAD_LEVEL',
};

/**
 * Constants definition.
 *
 * @type {{
 * NATURAL_SCIENCES: string,
 * ENGINEERING_TECHNOLOGY: string,
 * MEDICINE_HEALTH: string,
 * AGRICULTURE_VETERINARY: string,
 * SOCIAL_SCIENCES: string,
 * HUMANITIES_ARTS: string
 * }}
 */
const STUDY_CLASSIFICATIONS = {
  NATURAL_SCIENCES: 'NATURAL_SCIENCES',
  ENGINEERING_TECHNOLOGY: 'ENGINEERING_TECHNOLOGY',
  MEDICINE_HEALTH: 'MEDICINE_HEALTH',
  AGRICULTURE_VETERINARY: 'AGRICULTURE_VETERINARY',
  SOCIAL_SCIENCES: 'SOCIAL_SCIENCES',
  HUMANITIES_ARTS: 'HUMANITIES_ARTS',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const STUDY_LEVELS_ENUM = Object.keys(STUDY_LEVELS);
const STUDY_CLASSIFICATIONS_ENUM = Object.keys(STUDY_CLASSIFICATIONS);

export {
  STUDY_CLASSIFICATIONS,
  STUDY_CLASSIFICATIONS_ENUM,
  STUDY_LEVELS_ENUM,
  STUDY_LEVELS,
};
